import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthForm } from '../../components/AuthForm/AuthForm';
import signInImg from '../../assets/img/account_login.jpg';
import SignInCodeForm from '../../components/SignInCodeForm/SignInCodeForm';



const AuthCodePage = () => {
    const { t } = useTranslation();
    const handleLogin = () => console.log('Login succesfull');



    return (
        <AuthForm
            isLogin={true}
            image={signInImg}
            title={t('Code.title')}
            subtitle={t('Code.subtitle')}>
            <SignInCodeForm onLogin={handleLogin}></SignInCodeForm>
        </AuthForm>
    );
}
export default AuthCodePage;